import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2, ArrowRight } from "lucide-react";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

const HERO = "https://images.unsplash.com/photo-1548992725-accdba0a1cc1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to={user.role === "admin" ? "/admin" : "/driver"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-[1.1fr_1fr] bg-white">
      <div className="relative hidden lg:block overflow-hidden grain">
        <img src={HERO} alt="Tour" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-slate-950/60" />
        <div className="relative h-full flex flex-col justify-end p-12 text-white">
          <p className="text-xs uppercase tracking-[0.3em] text-emerald-400 font-semibold">Dewata Memories Tours</p>
          <h2 className="font-heading text-5xl font-extrabold tracking-tight mt-3 max-w-lg leading-[1.05]">Report kerja driver, rapi tiap trip.</h2>
          <p className="text-slate-300 mt-4 max-w-md">Catat tour, jumlah tamu, tiket dan extra. Admin cek, bayar, dan lampirkan bukti transfer di satu tempat.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6 rise" data-testid="login-form">
          <div>
            <img src="/logo.png" alt="Dewata Memories Tours" className="h-24 w-24 object-contain -ml-2 mb-2" data-testid="login-logo" />
            <p className="text-xs uppercase tracking-[0.25em] text-emerald-600 font-semibold">Dewata Memories Tours</p>
            <h1 className="font-heading text-4xl font-extrabold tracking-tight text-slate-900 mt-2">Masuk</h1>
            <p className="text-sm text-slate-500 mt-2">Login untuk Admin dan Team Driver. Akun team dibuat oleh admin.</p>
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required autoComplete="email" className="h-11" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required autoComplete="current-password" className="h-11" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" />
          </div>
          {error && <p className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg px-3 py-2" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full h-11 bg-emerald-600 hover:bg-emerald-700 font-semibold group" data-testid="login-submit-btn">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Masuk <ArrowRight className="h-4 w-4 ml-1 transition-transform group-hover:translate-x-1" /></>}
          </Button>
        </form>
      </div>
    </div>
  );
}
